import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import TrustBar from "@/components/landing/TrustBar";
import PainSection from "@/components/landing/PainSection";
import Conversion from "@/components/landing/Conversion";
import ServicesPillars from "@/components/landing/ServicesPillars";
import Gallery from "@/components/landing/Gallery";
import Trust from "@/components/landing/Trust";
import Pricing from "@/components/landing/Pricing";
import AreasWeServe from "@/components/landing/AreasWeServe";
import WhatsAppCTA from "@/components/landing/WhatsAppCTA";
import Reviews from "@/components/landing/Reviews";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import VisitOffice from "@/components/landing/VisitOffice";
import Footer from "@/components/landing/Footer";
import OfferPopup from "@/components/landing/OfferPopup";
import FloatingActions from "@/components/landing/FloatingActions";
import StickyMobileBar from "@/components/landing/StickyMobileBar";

export default function LandingPage() {
  const scrollToForm = () => {
    document.getElementById("lead-form")?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div data-testid="landing-page" className="min-h-screen bg-white text-neutral-900 pb-16 lg:pb-0">
      <Header onCtaClick={scrollToForm} />
      <main>
        <Hero />
        <TrustBar />
        <PainSection />
        <Conversion />
        <ServicesPillars />
        <Gallery />
        <Trust />
        <Pricing />
        <AreasWeServe />
        <WhatsAppCTA />
        <Reviews />
        <FAQ />
        <FinalCTA />
        <VisitOffice />
      </main>
      <Footer />
      <OfferPopup />
      <FloatingActions />
      <StickyMobileBar />
    </div>
  );
}
